import I18n from 'core/i18n'

interface IPostStatusLike {
  aasm_state: string
  limited_access?: boolean
  aasm_state_i18n?: string
  dmc_tour_id?: number | null
}

// DMCツアーの post は常に下書きのため 'dmc'、限定公開中の post は aasm_state 上は 'published' のため、UI 用にキーを分ける
export const getPostStatusKey = (post: IPostStatusLike): string => {
  if (post.dmc_tour_id) {
    return 'dmc'
  }
  return post.aasm_state === 'published' && post.limited_access
    ? 'limited_published'
    : post.aasm_state
}

// 一覧などで表示するステータスラベル。DMC・限定公開のみ専用文言、それ以外はサーバ側の i18n を使う
export const getPostStatusLabel = (post: IPostStatusLike): string | undefined => {
  const key = getPostStatusKey(post)
  if (key === 'dmc') {
    return I18n.t('post.dmc')
  }
  return key === 'limited_published'
    ? I18n.t('post.limited_access_published_short')
    : post.aasm_state_i18n
}
